import React, { Component } from "react"
import { LoadModalWithLabel } from "../modais"
import { withRouter } from "react-router-dom"
import {
  InputCustom,
  InputMaskCustom,
  Loading,
  HttpError
} from "../../components"
import * as ApiHelper from "../../ApiHelper"

class ComissaoItemForm extends Component {
  constructor() {
    super()
    this.getInitialFields = this.getInitialFields.bind(this)
    this.fillFields = this.fillFields.bind(this)
    this.onChangeCPF = this.onChangeCPF.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.onChangeMatricula = this.onChangeMatricula.bind(this)
    this.onChangeUnidadeLotacao = this.onChangeUnidadeLotacao.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      nome: "",
      matricula: "",
      unidadeLotacao: "",
      cpf: "",
      termoID: "",
      showForm: false
    }
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  onChangeCPF(event, id) {
    var newValue = event.target.value
    this.setState({
      cpf: newValue,
      cpfError: ""
    })
  }
  onChangeNome(event, id) {
    var newValue = event.target.value
    this.setState({
      nome: newValue,
      nomeError: ""
    })
  }
  onChangeUnidadeLotacao(event, id) {
    var newValue = event.target.value
    this.setState({
      unidadeLotacao: newValue,
      unidade_lotacaoError: ""
    })
  }
  onChangeMatricula(event, id) {
    var newValue = event.target.value
    this.setState({
      matricula: newValue,
      matriculaError: ""
    })
  }
  componentWillMount() {
    this.getInitialFields()
  }

  getInitialFields() {
    ApiHelper.getComissaoItemEdit(this.props.itemID, (comissaoItem, error) => {
      if (comissaoItem) {
        this.fillFields(comissaoItem)
        this.setState(
          {
            showForm: true
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      nome: this.state.nome,
      unidade_lotacao: this.state.unidadeLotacao,
      matricula: this.state.matricula,
      cpf: this.state.cpf,
      tc_id: this.state.termoID
    }
    this.toggleLoadModal()
    ApiHelper.updateComissaoItem(this.props.itemID, params, error => {
      this.toggleLoadModal()
      if (error) {
        this.handleErrors(error)
      } else {
        this.props.callBackItem()
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  fillFields(fields) {
    var currentFields = {
      nome: fields.nome,
      cpf: fields.cpf,
      unidadeLotacao: fields.unidade_lotacao,
      matricula: fields.matricula,
      termoID: fields.tc_id,
      nomeLabel: fields.nome
    }
    this.setState(currentFields)
  }
  render() {
    if (this.state.httpError) {
      return (
        <HttpError
          message={this.state.httpError.message}
          status={this.state.httpError.status}
        />
      )
    }
    return (
      <div>
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        {this.state.showForm === false && <Loading />}
        {this.state.showForm === true && (
          <div className="card card-plain">
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">Editar item da comissão</h4>
              <p className="category">
                {"Editar item da comissão: " + this.state.nomeLabel}
              </p>
            </div>
            <div className="card-content">
              <form>
                <div className="row">
                  <InputCustom
                    error={this.state.nomeError}
                    type="text"
                    sizeClass="col-md-2"
                    value={this.state.nome}
                    label="Nome"
                    onChange={this.onChangeNome}
                  />
                  <InputMaskCustom
                    error={this.state.cpfError}
                    mask="999.999.999-99"
                    sizeClass="col-md-2"
                    label="CPF"
                    type="text"
                    onChange={this.onChangeCPF}
                    value={this.state.cpf}
                  />
                  <InputCustom
                    error={this.state.matriculaError}
                    type="text"
                    sizeClass="col-md-2"
                    value={this.state.matricula}
                    label="Matrícula"
                    onChange={this.onChangeMatricula}
                  />
                  <InputCustom
                    error={this.state.unidade_lotacaoError}
                    type="text"
                    sizeClass="col-md-2"
                    value={this.state.unidadeLotacao}
                    label="Unidade de lotação"
                    onChange={this.onChangeUnidadeLotacao}
                  />
                </div>
                <button
                  onClick={this.sendForm}
                  className="btn btn-primary pull-right"
                  data-background-color="as-blue"
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    )
  }
}
export default withRouter(ComissaoItemForm)



// WEBPACK FOOTER //
// ./src/views/modais/ComissaoItemForm.js